/* ==========================================================================
   Global Variables & reCAPTCHA Callback
   ========================================================================== */

/* Глобальная переменная для отслеживания, какая форма инициировала reCAPTCHA.
  Это необходимо, так как callback от Google глобальный.
*/
window.currentSubmittingForm = null;

window.onSubmit = function(token) {
  const form = window.currentSubmittingForm;
  if (!form) return;

  let tokenEl = form.querySelector('[name="g-recaptcha-response"]');
  if (!tokenEl) {
    tokenEl = document.createElement('textarea');
    tokenEl.name = 'g-recaptcha-response';
    tokenEl.style.display = 'none';
    form.appendChild(tokenEl);
  }
  tokenEl.value = token || tokenEl.value || '';

  form.dispatchEvent(new CustomEvent('recaptcha-verified', { bubbles: true }));
};

document.addEventListener('DOMContentLoaded', () => {

  /* ==========================================================================
     UI / Layout Helpers (Scroll, Header, Navigation)
     ========================================================================== */

  const yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  const scrollBtn = document.getElementById('scrollTopBtn');
  if (scrollBtn) {
    window.addEventListener('scroll', () => {
      scrollBtn.style.display = window.pageYOffset > 200 ? 'block' : 'none';
    });
    scrollBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // Smooth anchors with dynamic fixed header offset
  const EXTRA_HEADER_PAD = 0; // extra pixels to ensure titles clear the header

  // Делаем функцию доступной глобально (или внутри модуля), так как она нужна при валидации
  const getHeaderOffset = () => {
    const candidates = Array.from(document.querySelectorAll('header'));
    let offset = 0;

    candidates.forEach(el => {
      const cs = getComputedStyle(el);
      const pos = cs.position;
      if (pos !== 'fixed' && pos !== 'sticky') return;

      const rect = el.getBoundingClientRect();
      const nearTop = rect.top <= 1;
      if (nearTop || pos === 'sticky') {
        offset += rect.height;
      }
    });

    if (offset === 0) {
      const h = document.querySelector('header');
      if (h) offset = h.getBoundingClientRect().height;
    }

    return Math.ceil(offset + EXTRA_HEADER_PAD);
  };

  const debounceGlobal = (fn, t = 150) => { let id; return (...a) => { clearTimeout(id); id = setTimeout(() => fn(...a), t); }; };

  function scrollToWithOffset(target, behavior = 'smooth') {
    if (!target) return;
    const firstOffset = getHeaderOffset();
    const firstY = target.getBoundingClientRect().top + window.pageYOffset - firstOffset;
    window.scrollTo({ top: Math.max(0, firstY), behavior });

    setTimeout(() => {
      const secondOffset = getHeaderOffset();
      const secondY = target.getBoundingClientRect().top + window.pageYOffset - secondOffset;
      window.scrollTo({ top: Math.max(0, secondY), behavior: 'auto' });
    }, 350);
  }

  function updateScrollMargins() {
    const off = getHeaderOffset();
    document.documentElement.style.setProperty('--header-offset', `${off}px`);
    const ids = Array.from(document.querySelectorAll('a[href^="#"]'))
      .map(a => a.getAttribute('href'))
      .filter(href => href && href.length > 1)
      .map(href => href.trim());
    const unique = Array.from(new Set(ids));
    unique.forEach(sel => {
      const el = document.querySelector(sel);
      if (el) el.style.scrollMarginTop = `${off + 1}px`;
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      if (anchor.classList.contains('process__nav-item')) return;
      if (anchor.closest('header, .site-header, .navbar, [data-fixed-header]')) return;

      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        scrollToWithOffset(target, 'smooth');
        if (history.replaceState) {
          history.replaceState(null, '', location.pathname + location.search);
        }
      }
    });
  });

  document.querySelectorAll('header a[href*="#"], .site-header a[href*="#"], .navbar a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const rawHref = anchor.getAttribute('href') || '';
      let url;
      try { url = new URL(rawHref, location.href); } catch { return; }
      const { hash, pathname, origin } = url;
      if (!hash) return;
      if (origin !== location.origin) return;
      if (pathname !== location.pathname) return;

      const target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();
      scrollToWithOffset(target, 'smooth');
      if (history.replaceState) {
        history.replaceState(null, '', location.pathname + location.search);
      }
    });
  });

  if (location.hash) {
    const initialTarget = document.querySelector(location.hash);
    if (initialTarget) {
      setTimeout(() => {
        scrollToWithOffset(initialTarget, 'auto');
        if (history.replaceState) {
          history.replaceState(null, '', location.pathname + location.search);
        }
      }, 0);
    }
  }

  updateScrollMargins();
  window.addEventListener('resize', debounceGlobal(updateScrollMargins, 150));
  window.addEventListener('orientationchange', updateScrollMargins);

  // Navbar logic
  const BREAKPOINT = 992;
  const menu = document.getElementById('navbarMenu');
  const toggler = document.querySelector('.mobile-nav-trigger__btn');
  if (menu && window.bootstrap) {
    const isDesktop = () => window.innerWidth >= BREAKPOINT;
    const inst = () => bootstrap.Collapse.getOrCreateInstance(menu, { toggle: false });

    menu.querySelectorAll('.nav-link').forEach(link => {
      link.addEventListener('click', () => {
        if (!isDesktop()) {
          inst().hide();
          if (toggler) toggler.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Close mobile menu on header CTA (e.g., "Get a quote") click as well
    menu.querySelectorAll('.cta a[href^="#"], a.btn[href^="#"]').forEach(link => {
      link.addEventListener('click', () => {
        if (!isDesktop()) {
          inst().hide();
          if (toggler) toggler.setAttribute('aria-expanded', 'false');
        }
      });
    });

    const syncToViewport = () => {
      if (isDesktop()) {
        inst().show();
        menu.classList.remove('collapsing');
        menu.style.height = '';
        if (toggler) toggler.setAttribute('aria-expanded', 'true');
      } else {
        inst().hide();
        if (toggler) toggler.setAttribute('aria-expanded', 'false');
      }
    };
    syncToViewport();
    window.addEventListener('resize', debounceGlobal(syncToViewport, 150));
  }

  /* ==========================================================================
   Quote forms: validation, reCAPTCHA, submit (universal)
   ========================================================================== */

  // Ищем все формы с .g-recaptcha и нужными полями
  const quoteForms = Array.from(document.querySelectorAll('form')).filter((form) =>
    form.querySelector('.g-recaptcha') &&
    form.querySelector('[name="firstName"]') &&
    form.querySelector('[name="lastName"]') &&
    form.querySelector('[name="email"]') &&
    form.querySelector('[name="phone"]')
  );

  quoteForms.forEach(setupQuoteForm);

  function setupQuoteForm(form) {
    form.setAttribute('novalidate', 'novalidate');

    const getField = (name) => form.querySelector(`[name="${name}"]`);

    const fields = {
      firstName: getField('firstName'),
      lastName:  getField('lastName'),
      email:     getField('email'),
      phone:     getField('phone'),
    };

    const messages = {
      firstName: 'Please enter your first name.',
      lastName:  'Please enter your last name.',
      email:     'Please enter a valid email.',
      phone:     'Please enter a valid phone number.',
    };

    const validators = {
      firstName: (v) => v.trim().length > 0,
      lastName:  (v) => v.trim().length > 0,
      email:     (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v.trim()),
      phone:     (v) => /^\+?[0-9\s()-]{7,15}$/.test(v.trim()),
    };

    function getFeedbackEl(input) {
      if (!input) return null;
      const parent =
        input.closest('.mb-3, .form-group, .col, .col-md-6, .col-md-12') ||
        input.parentElement;
      return parent ? parent.querySelector('.invalid-feedback') : null;
    }

    function setFieldState(input, ok, msg) {
      if (!input) return;
      input.classList.toggle('is-invalid', !ok);
      input.classList.toggle('is-valid', ok);
      const fb = getFeedbackEl(input);
      if (fb && !ok) fb.textContent = msg || '';
    }

    function validateField(name) {
      const input = fields[name];
      if (!input) return true;
      const val = input.value || '';
      const ok = validators[name] ? validators[name](val) : true;
      setFieldState(input, ok, messages[name]);
      return ok;
    }

    function validateForm() {
      const order = ['firstName', 'lastName', 'email', 'phone'];
      let allOk = true;
      let firstBad = null;

      for (const key of order) {
        const ok = validateField(key);
        if (!ok && !firstBad) firstBad = fields[key];
        allOk = allOk && ok;
      }

      if (!allOk && firstBad) {
        firstBad.focus({ preventScroll: true });
        // Для инлайновой формы — скроллим к полю
        if (!form.closest('.modal')) {
          const rect = firstBad.getBoundingClientRect();
          const headerOff = getHeaderOffset();
          const top = rect.top + window.pageYOffset - headerOff - 20;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }

      return allOk;
    }

    // live-валидация
    Object.keys(fields).forEach((key) => {
      const el = fields[key];
      if (!el) return;
      el.addEventListener('input', () => validateField(key));
      el.addEventListener('blur', () => validateField(key));
    });

    // Кнопка reCAPTCHA
    const recaptchaBtn = form.querySelector('.g-recaptcha');

    if (recaptchaBtn) {
      recaptchaBtn.addEventListener('click', (e) => {
        // 1) валидируем форму
        if (!validateForm()) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        // 2) запоминаем форму для window.onSubmit
        window.currentSubmittingForm = form;
        // дальше клик летит в reCAPTCHA, она вызовет window.onSubmit()
      });
    }

    // 3) после успешной капчи (вызывается из window.onSubmit)
    form.addEventListener('recaptcha-verified', () => {
      if (!validateForm()) return;
      submitQuoteForm(form);
    });
  }

  function submitQuoteForm(form) {
    const inModal  = !!form.closest('.modal');
    const modal    = inModal ? form.closest('.modal') : null;
    const modalBody = modal ? modal.querySelector('.modal-body') : null;
    const submitBtn =
      form.querySelector('button.g-recaptcha') || form.querySelector('button[type="submit"]');

    const setSubmitting = (isSubmitting) => {
      if (!submitBtn) return;
      if (isSubmitting) {
        if (!submitBtn.dataset.originalText) {
          submitBtn.dataset.originalText = submitBtn.textContent;
        }
        submitBtn.disabled = true;
        submitBtn.classList.add('disabled');
        submitBtn.textContent = 'Sending...';
      } else {
        submitBtn.disabled = false;
        submitBtn.classList.remove('disabled');
        if (submitBtn.dataset.originalText) {
          submitBtn.textContent = submitBtn.dataset.originalText;
        }
      }
    };

    const resetFormUI = () => {
      form.reset();
      form.classList.remove('was-validated');
      form.querySelectorAll('.is-valid, .is-invalid').forEach((el) => {
        el.classList.remove('is-valid', 'is-invalid');
      });
      const tokenEl = form.querySelector('[name="g-recaptcha-response"]');
      if (tokenEl) tokenEl.value = '';
      setSubmitting(false);
    };

    setSubmitting(true);

    const action = form.getAttribute('action') || './send_form.php';
    const fd = new FormData(form);

    if (!fd.has('pagePath')) {
      fd.append('pagePath', window.location.pathname);
    }
    if (!fd.has('formContext')) {
      fd.append('formContext', inModal ? 'modal' : 'inline');
    }

    fetch(action, { method: 'POST', body: fd })
      .then(async (res) => {
        const text = await res.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          data = { status: 'error' };
        }
        const ok = res.ok && data && data.status === 'success';

        if (modalBody) {
          // Модалка
          form.style.display = 'none';
          const status = document.createElement('div');
          status.className = 'text-center py-4';
          status.innerHTML = ok
            ? '<h5 class="mb-2">Sent</h5><p class="mb-3">Thank you! We will contact you shortly.</p><button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>'
            : '<h5 class="mb-2">Error</h5><p class="mb-3">Error sending request. Please try again.</p><button type="button" class="btn btn-warning" id="jsBackToForm">Return to form</button>';
          modalBody.appendChild(status);

          const backBtn = status.querySelector('#jsBackToForm');
          if (backBtn) {
            backBtn.addEventListener('click', () => {
              status.remove();
              form.style.display = '';
              resetFormUI();
            });
          }

          if (modal) {
            modal.addEventListener(
              'hidden.bs.modal',
              () => {
                if (status && status.parentNode) status.parentNode.removeChild(status);
                form.style.display = '';
                resetFormUI();
              },
              { once: true }
            );
          }
        } else {
          // Инлайн-форма
          if (ok) {
            form.innerHTML =
              '<div class="alert alert-success p-5 text-center"><h4>Thank you!</h4><p>Your request has been sent. We will contact you shortly.</p></div>';
          } else {
            alert('The form could not be sent. Please try again later.');
            setSubmitting(false);
          }
        }
      })
      .catch(() => {
        alert('The form could not be sent. Please try again later.');
        if (modalBody) {
          form.style.display = '';
          resetFormUI();
        } else {
          setSubmitting(false);
        }
      })
      .finally(() => {
        if (window.grecaptcha && typeof window.grecaptcha.reset === 'function') {
          try {
            window.grecaptcha.reset();
          } catch (e) {}
        }
      });
  }

  /* ==========================================================================
     Process Nav & Other Page Logic
     ========================================================================== */

  document.querySelectorAll('.process__nav-item').forEach((navItem) => {
    navItem.addEventListener('click', (event) => {
      event.preventDefault();
      const href = navItem.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;

      document.querySelectorAll('.process__nav-title').forEach(t => t.classList.remove('active'));
      const clickedTitle = navItem.closest('.process__nav-title');
      if (clickedTitle) clickedTitle.classList.add('active');

      scrollToWithOffset(target, 'smooth');

      if (history.replaceState) {
        history.replaceState(null, '', location.pathname + location.search);
      }
    });
  });

  const processSections = Array.from(document.querySelectorAll('.process__content-step'));
  const processTitles = Array.from(document.querySelectorAll('.process__nav-title'));

  function setActiveBySection(section) {
    processTitles.forEach(t => t.classList.remove('active'));
    if (!section) return;
    const id = `#${section.id}`;
    const link = document.querySelector(`.process__nav-item[href="${id}"]`);
    const title = link ? link.closest('.process__nav-title') : null;
    if (title) title.classList.add('active');
  }

  window.addEventListener('scroll', () => {
    const scrollPos = window.pageYOffset + getHeaderOffset() + 1;
    let current = null;
    for (const sec of processSections) {
      if (sec.offsetTop <= scrollPos) current = sec;
    }
    setActiveBySection(current);
  });

  const el = document.getElementById('lightgallery');
  if (!el || typeof lightGallery === 'undefined') return;

  lightGallery(el, {
    selector: '.gallery__item-link',
    plugins: [lgZoom],
    thumbnail: false,
    showThumbByDefault: false,
    animateThumb: false,
    allowMediaOverlap: true,
    toggleThumb: true,
    download: false,
    controls: true,
    loop: true,
    speed: 300,
    subHtml: false,
  });

});